export default "__VITE_ASSET__lkfj06uY__"